module.exports = __webpack_public_path__ + "img/press-06.2a555e29.jpeg";